import Vue from 'vue';
import './plugins/vuetify';
import './plugins/resource';
import App from './App.vue';
import router from './router';
import store from './store/store';
import { Vuelidate } from 'vuelidate';
import './filters/bytes-filter';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import './registerServiceWorker'
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
Vue.use(Vuelidate);
export default new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
